import * as bs from 'bootstrap';

export function initDataToast() {
    document.querySelectorAll('[data-toast]').forEach(x => {
        var element = <HTMLElement>x;
        var toast = new bs.Toast(element); 
        toast.show();
    });
}